import React, {useCallback} from "react";
import "./index.scss";
import Title from "features/components/title";
import {__} from "services/i18n";
import {connect} from "react-redux";
import {getUserSubscriptionStart} from "store/reducer/user/subscription/reducer";
import {
    getUserSubscriptionData,
    getUserSubscriptionErrorSelector,
    getUserSubscriptionLoading
} from "store/reducer/user/subscription/selectors";
import {profileData} from "store/reducer/user/profile/selectors";
import {TextField} from "features/components/text-field";
import Button from "features/components/button";
import moment, {ISO_8601} from "moment";
import {Icon} from "features/components/icon";
import Text from "features/components/text";
import {SUBSCRIPTIONS_DETAIL} from "constants.js";
import {changePasswordSetShow} from "features/modals/change-password/reducer";
import {changePasswordShowModal} from "features/modals/change-password/selectors";
import ChangePasswordModal from "features/modals/change-password";

/* istanbul ignore next */
const mapStateToProps = state => ({
    loading: getUserSubscriptionLoading(state),
    error: getUserSubscriptionErrorSelector(state),
    data: getUserSubscriptionData(state),
    profile: profileData(state),
    show_modal: changePasswordShowModal(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    getUserSubscriptionStart,
    changePasswordSetShow
};

export const SettingsAccount = (props) => {
    const {loading, error, data, profile, show_modal} = props;
    const {getUserSubscriptionStart, changePasswordSetShow} = props;

    React.useEffect(() => {
        getUserSubscriptionStart();
    },[getUserSubscriptionStart]);

    const doChangePassword = useCallback(() => {
        changePasswordSetShow(true);
    }, [changePasswordSetShow]);

    const renderSub = useCallback(() => {
        if((loading && !data) || !data) return <Icon>loader</Icon>
        if(error.inError) return <Text size={16} align={"center"} color={"danger"}>{__(error.error)}</Text>
        const planData = SUBSCRIPTIONS_DETAIL[data.plan];
        return <div className="account-subscription">
            <div className="plan-data">
                <div className="plan-name">
                    <Title size={20}>{planData.name}</Title>
                </div>
                <div className="plan-benefits">
                    <Text size={16}>{__("settings.tabs.account.plan", [{key: "[name]", value: planData.name}])}</Text>
                    {planData.benefits.map(
                        item => <div key={item} className={"row benefits"}>
                            <Icon>check-circle-outline</Icon><Text size={16}>{item}</Text>
                        </div>)}
                </div>
            </div>
            <div className="row sub-data">
                <TextField placeholder={__("settings.tabs.account.start")} type={"text"} value={moment(data.subscribed_at, ISO_8601).format("DD/MM/YYYY")} onChange={() => {}} disabled={true} />
                <TextField placeholder={__("settings.tabs.account.end")} type={"text"} value={moment(data.expires_at, ISO_8601).format("DD/MM/YYYY")} onChange={() => {}} disabled={true} />
                <TextField placeholder={__("settings.tabs.account.cost")} type={"text"} value={`€ ${data.amount / 100}`} onChange={() => {}} disabled={true} />
                {planData.upsell_name && <Button title={__("settings.tabs.account.upgrade-to", [{key: "[name]", value: planData.upsell_name}])}
                         onClick={() => window.open(planData.upsell_link, "_blank")} type={"accent"}/>}
            </div>
        </div>;
    }, [loading, error, data]);

    return <div className="settings-account">
        <Title size={18}>{__("settings.tabs.account.your-account")}</Title>
        {renderSub()}
        <Title size={18}>{__("settings.tabs.account.login-data")}</Title>
        <div className="row email-data">
            <TextField placeholder={__("text-fields.email.placeholder")} type={"text"} value={profile.email} onChange={() => {}} disabled={true} />
            <Button title={__("buttons.change-password")} onClick={doChangePassword} type={"outlined"} />
        </div>
        {show_modal && <ChangePasswordModal />}
    </div>
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsAccount);